export default "__VITE_ASSET__DpneJ3s8__"